export default {
  methods: {
    stopNativeChange(e) {
      if (e && e.stopPropagation) e.stopPropagation();
    },
  },
};
